import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SPPO CLOSE (CREATION SIDE) APIs
// Legacy route: /Purchase/SPPOClose
// Note: closeSPPOAPI.js in this same folder backs the *verification* page
// (VerifySPPOClose.jsx) and is registered under the "closeSPPO" store key —
// this file is the creation-side counterpart with its own slice/store key.
// ==============================================

const get = async (path, params, errMsg) => {
    try {
        const queryParams = new URLSearchParams(params || {});
        const qs = queryParams.toString();
        const response = await axios.get(
            `${API_BASE_URL}${path}${qs ? `?${qs}` : ''}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

export const getSPPOCCforClose = (userId, roleId) =>
    get('/Purchase/GetSPPOCCforClose', { Userid: userId, Roleid: roleId }, 'Get CC For SPPO Close API Error');

export const getVendorsForSPPOClose = (ccCode) =>
    get('/Purchase/GetVendorsForSPPOClose', { CCode: ccCode }, 'Get Vendors For SPPO Close API Error');

export const getPOForSPPOClose = (vendorCode, ccCode) =>
    get('/Purchase/GetPOForSPPOClose', { VendorCode: vendorCode, CCCode: ccCode }, 'Get PO For SPPO Close API Error');

export const getSPPOByNoForClose = (sppono, ccCode, vendorCode) =>
    get('/Purchase/GetSPPObyNoForAmend', { Sppono: sppono, CCCode: ccCode, VendorCode: vendorCode }, 'Get SPPO Details API Error');

export const closeSPPO = async (payload) => {
    try {
        const response = await axios.put(
            `${API_BASE_URL}/Purchase/CloseSPPO`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};
